import * as React from 'react';
import { Link } from 'react-router-dom';

interface ItemProps {
  link: string;
  label: string;
}

const Item = ({ link, label }: ItemProps) => {
  return (
    <li className="sub-item">
      <Link to={link} className="sub-link">
        {label}
      </Link>
    </li>
  );
};

export default Item;
